import React from "react";
import { Button, InputField } from "@vionixasia/shared-components";

/**
 * The category switch of every public results / start list page: buttons on a
 * wide screen, the shared select on a phone. Long names (SUMMIT FUN TRAIL 21K,
 * TEAM RELAY MEN U40) stacked the buttons three rows deep on a phone, and a
 * sideways-scrolling row hid the ones past the edge.
 *
 * Rendered inside the page's own flex row: the buttons stay its children
 * (`md:contents`), so the desktop layout is the one each page already had.
 */
export const CategoryPicker = ({ categories, selected, onSelect }) => (
  <>
    <InputField
      type="select"
      label="Category"
      labelClassName="sr-only"
      name="category"
      value={selected}
      onChange={(e) => onSelect(e.target.value)}
      options={categories.map((c) => ({ value: c.id, label: c.name }))}
      defaultOptionLabel={null}
      wrapperClassName="w-full md:hidden"
    />
    <div className="hidden md:contents">
      {categories.map((c) => (
        <Button key={c.id} onClick={() => onSelect(c.id)} variant={selected === c.id ? "primary" : "secondary"} color="slate">
          {c.name}
        </Button>
      ))}
    </div>
  </>
);
